export function getUser(state) {
    return state.user;
}

export function getRoles(state) {
    return state.roles;
}
